import {Address, Subscription, UserSettings} from 'Models'
import AbstractPiniaModel from '../models/AbstractPiniaModel'
import { useUserStore } from '../pinia/stores/user'
import Api from 'Ajax'
import { checkApiResponseForAuth } from '@features/_common/errorHandler';


export class User extends AbstractPiniaModel {
    //#region Instance Code
        constructor(user) { super(user) }


        id()             { return this.source.id }
        uuid()             { return this.source.uuid }
        title()             { return this.source.anrede }
        firstName()         { return this.source.vorname; }
        lastName()          { return this.source.name; }
        userName()          { return this.source.benutzer_name; }
        email()             { return this.source.email; }
        phone()             { return this.source.telephone; }
        address()           { return Address.create(this.source) }
        subscriptionIds()   { return this.source.subscription_ids }
        firstLogin()   { return (this.source && 'erster_login' in this.source) ? new Date(this.source.erster_login) : null  }

        subscriptions()
        {
            const subsIds = this.subscriptionIds() || []

            return subsIds.map(scID => Subscription.createFromId(scID))
                          .filter( s=>!s.isEmpty() )
        }

        belongsToInstitution()
        {
            return this.source.institution_id!==undefined && this.source.institution_id!==null
        }

        nickname()          { 
            if (this.source.chat_setting) {
                return this.source.chat_setting.nickname;
            }
            if (this.source.chatSetting) {
                return this.source.chatSetting.nickname;
            }
            return this.source.nickname || null;
        }
        hasNickname()       { return !!this.nickname() }
        avatarStyle()       {
            if (this.source.chat_setting?.avatar_style) {
                return this.source.chat_setting.avatar_style;
            }
            if (this.source.chatSetting?.avatar_style) {
                return this.source.chatSetting.avatar_style;
            }
            return null;
        }
        chatAvatarUser()    {
            return {
                id: this.id(),
                display_name: this.nickname() || `${this.firstName()} ${this.lastName()}`.trim() || 'User',
                avatar_style: this.avatarStyle(),
            };
        }
        acceptedRules()     { 
            if (this.source.chat_setting) {
                return !!this.source.chat_setting.accepted_rules_at;
            }
            if (this.source.chatSetting) {
                return !!this.source.chatSetting.accepted_rules_at;
            }
            return !!this.source.accepted_rules_at;
        }
        acceptedPrivacy()     {
            if (this.source.chat_setting) {
                return !!this.source.chat_setting.accepted_privacy_at;
            }
            if (this.source.chatSetting) {
                return !!this.source.chatSetting.accepted_privacy_at;
            }
            return !!this.source.accepted_privacy_at;
        }
    //#endregion Instance Code


    //#region Static Methods
        static piniaStore()        { return useUserStore() }
        static create(userSource)       { return new User(userSource) }

        static setUserTo(user)          { 
            this.dispatch('setUser', user.getSource()) 
        }
        static updateChatSetting(chatSettingObj) {
            const currentUserSource = Object.assign({}, this.current().getSource() || {})
            currentUserSource.chat_setting = chatSettingObj
            this.setUserTo(User.create(currentUserSource))
        }
        static current()                { return this.create(this.piniaStore().subscribedUser) }

        static exists()                 { return !this.current().isEmpty() }

        static updateTo(updatedUser)    {
            const updatedUserSource = {
                vorname:        updatedUser.firstName,
                name:           updatedUser.lastName,
                benutzer_name:  updatedUser.userName,
                email:          updatedUser.email,
                telephone:      updatedUser.phone,
                strasse:        updatedUser.street,
                hausnummer:     updatedUser.number,
                plz:            updatedUser.postcode,
                ort:            updatedUser.city,
                nickname:       updatedUser.nickname,
                avatar_style:   updatedUser.avatarStyle ?? updatedUser.avatar_style ?? undefined,
            }
            return Api  .postUpdatedUserData(updatedUserSource)
                        .then( response => {
                            const currentUserSource = this.current().getSource() || {}
                            const merged = Object.assign({}, currentUserSource, response.data || updatedUserSource)
                            const chatSetting = response.data?.chatSetting || response.data?.chat_setting
                            if (chatSetting) {
                                merged.chat_setting = {
                                    ...(currentUserSource.chat_setting || {}),
                                    ...chatSetting,
                                }
                            }
                            this.setUserTo(User.create(merged))
                            return response
                        })
                        .catch( err => {
                            checkApiResponseForAuth(this.ebus(), err)
                            throw err
                        } )
        }

        static changePwdTo(passwords)
        {
            return Api  .postChangedPassword(passwords)

            //.catch( err => checkApiResponseForAuth(AbstractModel.ebus(), err) )
        }

        static reset()
        {
            this.dispatch('setUser', null)
            UserSettings.setAllSettings({})
        }
    //#endregion Static Methods
}